import "./SocialDiv.css";

const SocialDiv = ({ logo, altStr, backgroundClr, onClickHandler }) => {
  return (
    <div className={`ptur-socialdivCont ${backgroundClr}`}>
      <div
        className="ptur-socialdivCont-overSelect"
        onClick={onClickHandler}
        id={altStr}
      ></div>
      <img src={logo} alt={altStr} style={{ height: "32px" }} />
    </div>
  );
};

export default SocialDiv;
